import { render, staticRenderFns } from "./ProgramLangBadges.vue?vue&type=template&id=3796bc27"
import script from "./ProgramLangBadges.vue?vue&type=script&lang=ts"
export * from "./ProgramLangBadges.vue?vue&type=script&lang=ts"
import style0 from "./ProgramLangBadges.vue?vue&type=style&index=0&id=3796bc27&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default})
